var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 124,
    viewBox: "0 0 178 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1007)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 124,
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.4043,
    y: 76.5078,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.24609,
    y: 76.5078,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.24609,
    y: 23.4199,
    width: 76.5088,
    height: 45.2807,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.8779,
    y: 23.4199,
    width: 76.5088,
    height: 45.2807,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.508,
    y: 23.4199,
    width: 76.5088,
    height: 45.2807,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.562,
    y: 76.5078,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.72,
    y: 76.5078,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.878,
    y: 76.5078,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid06);
export default __webpack_public_path__ + "static/media/grid_06.d198ba29c5671d82572b6305f4335cc4.svg";
export { ForwardRef as ReactComponent };